module.exports = __webpack_public_path__ + "static/media/cert-infrared2.f8c6dd7d.png";